import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../interfaces/product.interface';
import { AdminNotificationService } from '../../../services/admin-notification.service';
import { NotificationDrawerComponent } from '../notification-drawer/notification-drawer.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, NotificationDrawerComponent],
  templateUrl: './admin-layout.html',
  styleUrls: ['./admin-layout.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  currentUser: User | null = null;
  isSidebarCollapsed = false;
  isMobileSidebarOpen = false;
  activeMenu = 'dashboard';
  isMobile = false;
  isNotificationDrawerOpen = false;
  notificationCount = 0;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationService: AdminNotificationService
  ) {}

  ngOnInit() {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
    this.checkScreenSize();
    
    // Subscribe to notification count
    this.notificationService.unreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.notificationCount = count;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
    if (this.isMobile && this.isSidebarCollapsed) {
      this.isSidebarCollapsed = false;
    }
  }

  toggleSidebar() {
    if (this.isMobile) {
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    } else {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    }
  }

  closeMobileSidebar(event?: Event) {
    if (this.isMobile) {
      this.isMobileSidebarOpen = false;
    }
  }

  setActiveMenu(menu: string) {
    this.activeMenu = menu;
    if (this.isMobile) {
      this.closeMobileSidebar();
    }
  }

  logout() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
  }

  getPageTitle(): string {
    const routeMap: { [key: string]: string } = {
      'dashboard': 'Dashboard',
      'orders': 'Order Management',
      'products': 'Product Management',
      'categories': 'Category Management',
      'users': 'User Management',
      'settings': 'Settings'
    };
    return routeMap[this.activeMenu] || 'Dashboard';
  }

  toggleNotificationDrawer(): void {
    this.isNotificationDrawerOpen = !this.isNotificationDrawerOpen;
  }

  closeNotificationDrawer(): void {
    this.isNotificationDrawerOpen = false;
  }
} 